import { render, staticRenderFns } from "./MercadolibreList.vue?vue&type=template&id=d0229d02"
import script from "./MercadolibreList.vue?vue&type=script&lang=js"
export * from "./MercadolibreList.vue?vue&type=script&lang=js"
import style0 from "./MercadolibreList.vue?vue&type=style&index=0&id=d0229d02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports